(function (Drupal, once) {
    'use strict';

    Drupal.behaviors.duplicateBreadcrumb = {
        attach: function (context) {
            const breadcrumbTargets = once('breadcrumb-duplicate', '#breadcrumb', context);

            breadcrumbTargets.forEach(function (targetDiv) {
                // Find the original Drupal breadcrumb ol element
                const originalBreadcrumb = document.querySelector('.block-system-breadcrumb-block ol.breadcrumb');

                if (originalBreadcrumb) {
                    // Only clone if there are at least 2 breadcrumb items
                    const breadcrumbItems = originalBreadcrumb.querySelectorAll('li');
                    if (breadcrumbItems.length >= 2) {
                        const clonedBreadcrumb = originalBreadcrumb.cloneNode(true);
                        targetDiv.appendChild(clonedBreadcrumb);
                    }
                }
            });
        }
    };

})(Drupal, once);